import React, { useState, useEffect } from "react";
import Navbar from "./navbar";
import { useGetAllOrdersQuery } from "./store/api/orderApi";
import { useValidateUserAndGetDetailsQuery } from "./store/api/orderApi";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';


const Orders = ({ handleOrderSelection }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1250);
    useEffect(() => {
        window.addEventListener("resize", () => {
            const ismobile = window.innerWidth < 1250;
            if (ismobile !== isMobile) setIsMobile(ismobile);
        }, false);
    }, [isMobile]);
    const userInfo = useSelector((state) => state.authentication.userInfo);

    const { data: userData, isLoading: isUserInfoPresent } = useValidateUserAndGetDetailsQuery(userInfo?.emailId);

    const { data: orders = [], isLoading: loadingOrders } = useGetAllOrdersQuery(userData?.userFamilyProfileID, { skip: !userData?.userFamilyProfileID });


    const getDate = (date) => {
        const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

        const d = new Date(date);
        let month = months[d.getMonth()];

        let dateString = `${d.getDate()}${month}${d.getFullYear()}`;
        return dateString;
    }

    return (
        loadingOrders ?
            <div className="spinner">
                <Spinner animation="border" />
            </div>
            :
            <div style={{ marginTop: "4rem" }}>
                {
                    [...orders]?.sort((order1, order2) => new Date(order2.orderSubmittedDate) - new Date(order1.orderSubmittedDate)).map((order, index) =>
                        <NavLink to={`OrderDetails`}>

                            <div onClick={() => handleOrderSelection(order)} className="orderBorder" >
                                <h4>
                                    <i className="fas fa-archive"></i>

                                    {getDate(order.orderDeliveryDate)}-{order.orderNumber} {index == 0 ? "(Current order)" : ""}
                                </h4>
                                <div>
                                    Points: {parseFloat(order.orderPoints).toFixed(0)}
                                </div>
                            </div>
                        </NavLink>

                    )
                }
            </div>
    )


}

export default Orders;